import React, { FC } from 'react';
import { Autocomplete, TextField, Box, Typography, InputAdornment } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from 'react-i18next';

export type StepOption = {
    id: string;
    name: string;
    departmentName: string;
};

type AddStepAutocompleteProps = {
    options: StepOption[];
    onStepSelected: (step: StepOption) => void;
};

const AddStepAutocomplete: FC<AddStepAutocompleteProps> = ({ options, onStepSelected }) => {
    const { t: translate } = useTranslation(['orders']);

    return (
        <Autocomplete
            options={options}
            groupBy={(option) => option.departmentName || translate('orders:STEPS_WITHOUT_DEPARTMENT')}
            getOptionLabel={(option) => option.name}
            value={null}
            onChange={(_, value) => {
                if (value) {
                    onStepSelected(value);
                }
            }}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderInput={(params) => (
                <TextField
                    {...params}
                    placeholder={translate('orders:ADD_STEP')}
                    size="small"
                    InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                            <>
                                <InputAdornment position="start">
                                    <AddIcon fontSize="small" />
                                </InputAdornment>
                                {params.InputProps.startAdornment}
                            </>
                        ),
                    }}
                />
            )}
            renderOption={(props, option) => (
                <Box component="li" {...props} key={option.id}>
                    <Typography variant="body2">{option.name}</Typography>
                </Box>
            )}
            fullWidth
            blurOnSelect
        />
    );
};

export default AddStepAutocomplete;
